import React, { useEffect, useState } from "react";
import { Box, Typography, Grid, TextField, Paper, CircularProgress } from "@mui/material";
import {
	getProfileDetails, getEmployedInList, getHealthConditionList, getFamilyStatusList,
} from "../../../services/operations/userOperations";
import { styled } from "@mui/material/styles";

import { DecorativeCorner } from "../../common/DecorativeCorner"; // Import DecorativeCorner
import { StyledButton } from "../../common/FormStyles"; // Import StyledButton
import { Navigate, useNavigate } from "react-router-dom"; // Import useNavigate
import { styles } from "../../styles/styles";
const Section = styled(Paper)(({ theme }) => ({
	padding: theme.spacing(2),
	marginBottom: theme.spacing(2),
	borderRadius: "8px",
	backgroundColor: "#f9f9f9",
}));

const SKILLS_LIST = [
	{ id: 1, name: "Web Development" },
	{ id: 2, name: "Mobile Development" },
	{ id: 3, name: "UI/UX Design" },
	{ id: 4, name: "Project Management" },
	{ id: 5, name: "Data Analysis" },
	{ id: 6, name: "Digital Marketing" },
	{ id: 7, name: "Cloud Computing" },
	{ id: 8, name: "Artificial Intelligence" },
	{ id: 9, name: "Machine Learning" },
	{ id: 10, name: "Cybersecurity" },
];
const FATHER_STATUS_LABELS = {
	1: "Employed",
	2: "Business",
	3: "Retired",
	4: "Not Alive"
};
const MOTHER_STATUS = {
	1: "housewife",
	2: "employed",
	3: "business",
	4: "retired",
	5: "not_alive",
};
const FormContainer = styled(Paper)(({ theme }) => ({
	padding: theme.spacing(3),
	borderRadius: "8px",
	backgroundColor: "#ffffff",
	width: "95%",
	margin: "0 auto",
	[theme.breakpoints.down("sm")]: {
		padding: theme.spacing(2),
	},
	"& .form-content": {
		border: "2px solid #d3a260",
		padding: theme.spacing(3),
		borderRadius: "10px",
		[theme.breakpoints.down("sm")]: {
			padding: theme.spacing(2),
		},
	},
}));

const MatrimonyReviewPage = () => {
	let userType = sessionStorage.getItem("userType")
	const [health, setHealth] = useState([]);
	const [employId, setEmployedIn] = useState([]);
	const [famliystatus, setFamilyStatusList] = useState([]);
	const fetchfamliyStatus = async () => {
		try {
			const response = await getFamilyStatusList();
			if (response.status) {
				setFamilyStatusList(response.data)
			}
		} catch {
			console.log("error data not fetching famliystatus");
		}
	}
	const fetchHealth = async () => {
		try {
			const response = await getHealthConditionList();
			if (response.status) {
				setHealth(response.data)
			}
		} catch {
			console.log("error health detalies");

		}
	}
	const fetchdataEnployid = async () => {
		try {
			const response = await getEmployedInList();
			if (response.status) {
				setEmployedIn(response.data)
			}
		} catch (error) {
			console.error("Error getEmployedInList:", error);
		}
	}
	useEffect(() => {
		fetchdataEnployid();
		fetchHealth();
		fetchfamliyStatus();
	}, [])
	const [profileData, setProfileData] = useState(null);
	const [profileStrenth,setProfileStregth] = useState(0)
	const navigate = useNavigate(); // Initialize navigate
	const [images, setImages] = useState("");
	useEffect(() => {
		const fetchProfile = async () => {
			try {
				const response = await getProfileDetails();
				if (response.status) {
					setProfileStregth(response?.profileStrenth)
					setProfileData(response.data);
				}
			} catch (error) {
				console.error("Error fetching profile details:", error);
			}
		};

		fetchProfile();
	}, []);

	if (!profileData) {
		return <Typography>Loading...</Typography>;
	}

	const { personalDetails, educationDetails, familyDetails, partnerDetails } =
		profileData;
	const handlechange = (e) => {
		setImages(e.t.value)
	}

	const renderField = (label, value) => (
		<Grid item xs={12} sm={6}>
			<TextField
				fullWidth
				label={label}
				value={value || ""}
				variant="outlined"
				size="small"
				InputProps={{
					readOnly: true,
				}}
			/>
		</Grid>
	);

	const handleContinue = () => {
		if(userType){
			sessionStorage.removeItem("token")
			sessionStorage.removeItem("userType")
			window.location.href = "/"		
		}
		else if(profileData?.planStatus) {
			navigate("/profile/DetaliesDashbord?type=suggested-profiles"); // Redirect to /profile/DetaliesDashbord

		} else {
			navigate("/profile/payment")

		}
	};

	return (
		<Box >
			<Box
				sx={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
					flexDirection: { xs: "column", md: "row" },
					px: { xs: 0, sm: 25 },
					py: { xs: 2 }
				}}
			>
				<Box sx={{ textAlign: { xs: "center", md: "left" }, mb: { xs: 2, md: 0 } }}>
					<img
						src="/images/Frame 148.png"
						alt="Logo"
						style={{
							maxWidth: "330px",
							width: "100%",
							height: "auto",
						}}
					/>
				</Box>

				<Box
					sx={{
						position: "relative",
						width: 180,
						height: 180,
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<CircularProgress
						variant="determinate"
						value={100}
						size={120}
						thickness={3}
						sx={{
							position: "absolute",
							color: "#F0E0D0",
						}}
					/>
					<CircularProgress
						variant="determinate"
						value={profileStrenth}
						size={120}
						thickness={3}
						sx={{
							position: "absolute",
							color: "#B56E2C",
						}}
					/>
					<Box sx={{ textAlign: "center" }}>
						<Typography sx={{ fontSize: "30px", color: "#B56E2C" }}>{profileStrenth}%</Typography>
						<Typography sx={{ color: "#B56E2C" }}>completed</Typography>
					</Box>
				</Box>
			</Box>

			<FormContainer elevation={0} sx={{ ...styles.formCard }}>
				<div className="form-content">
					<DecorativeCorner
						sx={{ top: -20, left: -20, transform: "rotate(0deg)" }}
					/>
					<DecorativeCorner
						sx={{ top: -20, right: -20, transform: "rotate(0deg)" }}
					/>
					<DecorativeCorner
						sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }}
					/>
					<DecorativeCorner
						sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }}
					/>
					<Typography variant="h4" gutterBottom>
						Matrimony Profile Review
					</Typography>

					{/* Personal Details Section */}
					<Section>
						<Typography variant="h6" gutterBottom>
							Personal Details
						</Typography>
						<Grid container spacing={2}>
							{renderField("Marital status", profileData?.customerPersonalDetails?.maritalStatus)}
							{renderField("Adhar number", profileData.idProofNumber)}
							{renderField("Height", profileData?.customerPersonalDetails?.height)}
							{renderField("Mother Tougue", profileData?.customerPersonalDetails?.motherTongue?.name)}
							{renderField("Health Condition", profileData?.customerPersonalDetails?.healthCondition?.name)}
							{renderField("complexion", profileData?.customerPersonalDetails?.complexion)}
							{renderField("about", profileData?.customerPersonalDetails?.aboutMe)}
							{renderField(
								"Date of Birth",
								profileData?.customerPersonalDetails?.dateOfBirth
									? new Date(profileData.customerPersonalDetails.dateOfBirth).toLocaleDateString('en-GB')
									: ''
							)}
							{renderField(
								"Time of Birth",
								profileData?.customerPersonalDetails?.timeOfBirth
									? new Date(profileData.customerPersonalDetails.timeOfBirth).toLocaleTimeString('en-US', {
										hour: '2-digit',
										minute: '2-digit',
										hour12: true,
									})
									: ''
							)}
							{renderField("Birth Place", profileData?.customerPersonalDetails?.birthPlace)}
						</Grid>
					</Section>
					<Section>
						<Typography variant="h6" gutterBottom>
							Religion & Caste Information
						</Typography>
						<Grid container spacing={2}>
							{renderField("Religion", profileData?.customerCastDetails?.religion?.religionName)}
							{renderField("Caste", profileData?.customerCastDetails?.caste?.castName)}
							{renderField("Sub Caste", profileData?.customerCastDetails?.subCaste?.castName)}
							{/* {renderField("Converted Caste", profileData?.customerCastDetails.convertedCaste)}
							{renderField("Caste Not A Problem", profileData?.customerCastDetails.casteNotProblem)} */}
							{renderField("Gothram", profileData?.customerCastDetails.gothram)}
							{renderField("Uncle's Gothram", profileData?.customerCastDetails.unclesGothram)}
							{renderField("Star", profileData?.customerCastDetails?.star?.name)}
							{renderField("Moon Sign", profileData?.customerCastDetails?.moonsign?.name)}
							{renderField("Padam", profileData?.customerCastDetails.padam)}
							{renderField(
								"Kuja Dosham",
								personalDetails?.khujaDhosam ? "Yes" : "No"
							)}
						</Grid>
					</Section>
					<Section>
						<Typography variant="h6" gutterBottom>
							Lifestyle & Marital Status
						</Typography>
						<Grid container spacing={2}>
							{renderField("Do You Smoke", profileData?.customerLifeDetails.smoke)}
							{renderField("Do You Drink", profileData?.customerLifeDetails.drink)}
							{renderField("Hobbies", profileData?.customerLifeDetails?.hobbies)}
							{renderField("interests", profileData?.customerLifeDetails?.interests)}
							{renderField("Favourite music", profileData?.customerLifeDetails?.favouriteMusic)}

							{renderField("Sports", profileData?.customerLifeDetails?.sports)}
							{renderField("Fitness Activities", profileData?.customerLifeDetails?.fitnessActivities)}
							{renderField("Favourite Cuisine", profileData?.customerLifeDetails?.favouriteCuisine)}
							{renderField("Favourite Reads", profileData?.customerLifeDetails?.favouriteReads)}
							{renderField("Preferred Movies", profileData?.customerLifeDetails?.preferredMovies)}
							{renderField("Preferred Dress Style", profileData?.customerLifeDetails?.preferredDressStyle)}
							{renderField(
								"Favourite Food",
								profileData?.customerLifeDetails?.favouriteFood
							)}
							{renderField("Spoken Languages", profileData?.customerLifeDetails?.spokenLanguages)}
						</Grid>
					</Section>
					<Section>
						<Typography variant="h6" gutterBottom>
							Contact Details
						</Typography>
						<Grid container spacing={2}>
							{renderField("Country", profileData?.customerContactDetails?.country?.countryName)}
							{renderField("State", profileData?.customerContactDetails?.state?.stateName)}
							{renderField("District", profileData?.customerContactDetails?.district?.districtName)}
							{renderField("City", profileData?.customerContactDetails?.city?.cityName)}
							{renderField("Address", profileData?.customerContactDetails.address)}
							{renderField(
								"Phone Number",
								profileData?.customerContactDetails.alternateMobile
							)}
							{renderField("Alternate Email", profileData?.customerContactDetails.alternateEmail
							)}
						</Grid>
					</Section>
					<Section>
						<Typography variant="h6" gutterBottom>
							Application Info
						</Typography>
						<Grid container spacing={2}>
							{renderField(
								"Application Filling Person Name",
								profileData?.customerApplicationDetails.applicationFillingPersonName
							)}
							{renderField(
								"Phone Number",
								profileData?.customerApplicationDetails.applicationFillingPersonMobile
							)}
							{renderField("Source",
								profileData?.customerApplicationDetails?.source?.sourceName
							)}
							{renderField(
								" Nearest Branch",
								profileData?.customerApplicationDetails?.nearestBranch?.branchName

							)}
						</Grid>
					</Section>
					<Section>
						<Typography variant="h6" gutterBottom>
							Upload Images
						</Typography>
						<Grid container spacing={2}>
							<Grid item xs={12} md={6}>
								<Box
									sx={{
										border: "2px solid rgb(161, 150, 150)",
										textAlign: "center",
										padding: "10px"
									}}
								>
									<Box
										component="img"
										src={profileData.profilePicture}
										alt="Profile"
										sx={{
											width: { xs: "100%", md: "300px" },
											height: { xs: "auto", md: "300px" },
											objectFit: "cover",
											borderRadius: "10px"
										}}
									/>
								</Box>

							</Grid>
							<Grid item xs={12} md={6}>
								<Box
									sx={{
										border: "2px solid rgb(161, 150, 150)",
										textAlign: "center",
										padding: "10px"
									}}
								>
									<Box
										component="img"
										src={profileData.idProofPicture
										}
										alt="Profile"
										sx={{
											width: { xs: "100%", md: "300px" },
											height: { xs: "auto", md: "300px" },
											objectFit: "cover",
											borderRadius: "10px"
										}}
									/>
								</Box>

							</Grid>
						</Grid>
					</Section>


					{/* Education Details Section */}
					<Section>
						<Typography variant="h6" gutterBottom>
							Education Details
						</Typography>
						<Grid container spacing={2}>
							{renderField("Education", profileData?.educationDetails?.education?.educationName)}
							{renderField("University", profileData?.educationDetails?.university?.univercityName)}
							{renderField("Profession", profileData?.educationDetails?.profession?.professionName)}
							{renderField("Institution Name", educationDetails?.institutionName)}
						</Grid>
					</Section>
					<Section>
						<Typography variant="h6" gutterBottom>
							Job Details						</Typography>
						<Grid container spacing={2}>

							{renderField(
								"Designation",
								profileData?.jobDetails?.designation?.designationName
							)}
							{renderField(
								"Company Name",
								profileData?.jobDetails.companyName
							)}
							{renderField("Working Location", profileData?.jobDetails?.workingLocation?.cityName
							)}
							{renderField(
								"Working State",
								profileData?.jobDetails?.state?.stateName
							)}
							{renderField(
								"Select contry",
								profileData?.jobDetails?.country?.countryName

							)}
								{/* {renderField(
								"Select city",
								profileData?.jobDetails?.city?.cityName

							)} */}
							{renderField(
								"Working Since",
								profileData?.jobDetails.workingSince
							)}
							{renderField(
								"Total Expirence",
								profileData?.jobDetails.totalExperience
							)}
							{renderField(
								"Colleagues Name & Mobile Numbere",
								profileData?.jobDetails.colleagueNameAndmobileNumber
							)}
							{renderField(
								"Annual Income",
								profileData?.jobDetails.annualIncome
							)}
							{renderField(
								"Propertiy Detalies ",
								profileData?.jobDetails.propertyDetails
							)}
							{renderField(
								"Employed In",
								employId.find(emp => emp.id === profileData?.jobDetails?.employedIn)?.name || "N/A"
							)}

							{renderField(
								"Current Employer",
								profileData?.jobDetails.currentEmployer
							)}
							{renderField(
								"Previous Employer",
								profileData?.jobDetails.previousEmployer
							)}
							{renderField(
								"Skills",
								SKILLS_LIST.find(skill => skill.id === parseInt(profileData?.jobDetails?.skills))?.name || "N/A"
							)}

							{renderField(
								"Health Condetion",
								health.find(emp => emp.id === profileData?.jobDetails?.healthCondition)?.name || "N/A"
							)}
							{renderField(
								"Office Location Address",
								profileData?.jobDetails.officeLocation
							)}
						</Grid>
					</Section>


					{/* Family Details Section */}
					<Section>
						<Typography variant="h6" gutterBottom>
							Family Details
						</Typography>
						{/* // famliystatus.find(emp => emp.id === profileData?.familyDetails?.fatherStatus)?.name || "N/A" */}

						<Grid container spacing={2}>
							{renderField("Family Status", familyDetails?.familyStatus?.name)}
							{renderField("Family Type", familyDetails?.familyType?.name)}
							{renderField("Permanent Address", profileData?.familyDetails.familyPermanentAddress)}
							{renderField("Present Address", familyDetails?.familyPresentAddress)}
							{renderField("Brothers", familyDetails?.numberOfBrothers || "0")}
							{renderField("Sisters", familyDetails?.numberOfsisters || "0")}
							{renderField("Contry", profileData?.familyDetails?.country?.countryName)}
							{renderField("State", familyDetails?.state?.stateName)}
							{renderField("District", familyDetails?.district?.districtName)}
							{renderField("City", familyDetails?.city?.cityName)}
						</Grid>
					</Section>
					<Section>
						<Typography variant="h6" gutterBottom>
							Father Details
						</Typography>
						<Grid container spacing={2}>
							{renderField("Father Name", familyDetails?.fatherName)}
							{renderField(
								"Religion",
								familyDetails?.fatherReligion?.religionName
							)}
							{renderField("Caste", familyDetails?.fatherCast?.castName)}
							{renderField(
								"Family Status",
								FATHER_STATUS_LABELS[familyDetails?.fatherStatus] || "N/A"
							)}

							{renderField(
								"Father Phone Number",
								familyDetails?.fatherMobileNumber
							)}
							{renderField(
								"Is Father Converted Caste",
								familyDetails?.isFatherConvertedCaste === 1 ? "Yes" : "No"
															)}
							{renderField(
								"Father Health Condition",
								familyDetails?.fatherHealthCondition?.name
							)}
							{renderField(
								"Father Working Sector",
								familyDetails?.fatherWorkingSector?.name
							)}
							{renderField(
								"Father's Profession",
								familyDetails?.fatherProfession?.professionName
							)}
							{renderField("Father's Address", familyDetails?.fatherAddress)}
							{/* {renderField(
								"Father's Annual Income",
								familyDetails?.fatherAnualIncome
							)} */}
							{renderField(
								"Father's Property Details",
								familyDetails?.fatherPropertyDetails
							)}
							{/* {renderField("Pension", familyDetails?.pension)} */}
						</Grid>
					</Section>
					<Section>
						<Typography variant="h6" gutterBottom>
							Mother Details
						</Typography>
						<Grid container spacing={2}>

							{renderField("Mother's Name", familyDetails?.motherName)}
							{renderField("Mother's Religion", familyDetails?.motherReligion?.religionName)}
							{/* {renderField(
								"Gotra/Kul",
								familyDetails?.motherGotra
							)} */}
							{renderField("Mother Status",
								MOTHER_STATUS[familyDetails?.motherStatus] || "N/A"
							)}
							{renderField(
								"Mother Moblie Number",
								familyDetails?.motherMobileNumber
							)}
							{renderField(
								"Mother Maiden Name",
								familyDetails?.motherMaidenName
							)}
							{renderField(
								"Is Mother Converited Caste",
								familyDetails?.isMotherConvertedCaste === 1 ? "Yes" : "No"
															)}
							{renderField(
								"Mother's Health Condition",
								familyDetails?.motherHealthCondition?.name
							)}

							{renderField(
								"Mother's Profession",
								familyDetails?.motherProfession?.professionName
							)}
							{/* {renderField(
								"Mother's Annual Income", familyDetails?.motherAnualIncome
							)} */}
							{renderField(
								"Mother's Property Details",
								familyDetails?.motherPropertyDetails
							)}
						</Grid>
					</Section>
					<Section>
						<Typography variant="h6" gutterBottom>
							Reference Details
						</Typography>
						<Grid container spacing={2}>

							{renderField(
								"Full Name",
								familyDetails?.referenceName
							)}
							{renderField(
								"MoblieNumer", familyDetails?.motherMobileNumber
							)}
							{renderField(
								"Relation",
								familyDetails?.relation?.name
							)}
							{renderField("Address", familyDetails?.referenceAddress)}

						</Grid>
					</Section>

					{/* Partner Preferences Section */}
					<Section>
						<Typography variant="h6" gutterBottom>
							Partner Preferences
						</Typography>
						<Grid container spacing={2}>
							{renderField("Famliy Status",
								famliystatus.find(emp => emp.id === profileData?.familyDetails?.fatherStatus)?.name || "N/A")}
							{renderField("Age From", partnerDetails?.ageFrom)}
							{renderField("Age To", partnerDetails?.ageTo)}
							{renderField("Height From", `${partnerDetails?.heightFrom} cm`)}
							{renderField("Height To", `${partnerDetails?.heightTo} cm`)}
							{renderField(
								"Ready for Inter-caste Marriage",
								partnerDetails?.readyForInterCasteMarriage === 1 ? "Yes" : "No"
							)}
							{renderField(
								"Looking For Same Converted",
								partnerDetails?.lookingForSameConvertedCast === 1
									? "Yes"
									: "No"
							)}
							{renderField(
								"Kuja Dosham",
								partnerDetails?.khujaDhosham === 1 ? "Yes" : "No"
							)}
							{renderField("Complexion", partnerDetails?.complexion)}
							{renderField("Caste", partnerDetails?.preferCastes)}
							{renderField("Smoke", partnerDetails?.smoke === 1 ? "Yes" : "No")}
							{renderField("Drink", partnerDetails?.drink === 1 ? "Yes" : "No")}
							{renderField("Education", partnerDetails?.preferEducation)}
							{renderField("Profession", partnerDetails?.preferProfession)}

							{renderField("Working Location", partnerDetails?.preferWorkingLocation)}
							{renderField(
								"Passport",
								partnerDetails?.passport === 1 ? "Yes" : "No"
							)}
							{renderField("Anual Income", partnerDetails?.anualIncomeFrom)}

						</Grid>
					</Section>

					<StyledButton
						variant="contained"
						onClick={handleContinue}
						sx={{
							width: { xs: "100%", sm: "160px" },
							marginTop: { xs: 3, md: 4 },
							padding: "15px 0px",
						}}
					>
						Save & Continue
					</StyledButton>
				</div>
			</FormContainer>
		</Box>
	);
};

export default MatrimonyReviewPage;
